module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAAyBAMAAABYG2ONAAAAG1BMVEX/AAAAcy9tr4n///////8kJCQkJCQAAAAAAACUHt63AAAACXRSTlP//8b//sbF//6tDrlVAAAANUlEQVR42mNiQAKMgsQAJgaSwaiWUS3DUAsZ+YUoLUKjgTyqZVQLmKNEDKBUy2i8jGoZSVoAosMRoKVpnx0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ae.png
// module id = qL2W
// module chunks = 0